import _ from "lodash";
import { SPEC_IMAGE_CAMERA_ANGLES } from "./SpecsDefinitions.mjs";
import SingleValueSelector from "../../../components/common/editors/SingleValueSelector";

//TODO: Read from schema
const imageSpecValues = _.values(SPEC_IMAGE_CAMERA_ANGLES).map(v => ({ label: v.replace('perspective-', '📦 '), value: v }));

export default function ({ value, onChange, ...other }) {
    return <span style={{minWidth: '200px'}}>
        <SingleValueSelector className={'zoom-75'} value={value} options={imageSpecValues} onChange={onChange} />
    </span>
}
